import { FilterConfigBuilder } from '@juvare/common-data-table-ui/FiltersBar/utils';
import { AccountFilterData } from '@juvare/contact-management/ui/features/accounts';
import { TFunction } from 'i18next';

export const getExtendRmsAccountFilters = (builder: FilterConfigBuilder<AccountFilterData>, t: TFunction<'rms'>) => {
    builder.quickFilterMultiSelect({
        widget: 'form.multiSelect',
        dataPath: 'occupations',
        label: t('accountsFilters.occupation.occupation'),
        valueProvider: {
            type: 'classifier.occupation',
        },
        sx: { maxWidth: { xs: undefined, sm: 280 } },
    });
};
